import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Company } from 'app/models/company.model';
import { Poligon } from 'app/models/poligon.model';
import { CompanyService } from 'app/services/company.service';
import { PoligonService } from 'app/services/poligon.service';
import { ToasterService } from 'app/services/user-interaction/services/toaster.service';
import { BaseFormComponent } from "../../base-form.component";

@Component({
    selector: "mia-poligon-form",
    templateUrl: "./poligon-form.component.html",
    styleUrls: ["./poligon-form.component.css"],
    providers: [PoligonService]
})

export class PoligonFormComponent extends BaseFormComponent implements OnInit {
    public companyId: number
    /** */
    @Output() public close = new EventEmitter();
    @Output() public done = new EventEmitter();

    public selectedCompany: number;
    public companyList: Array<Company>
    public get model(): Poligon {
        return this._data;
    }

    constructor(
        @Inject(MAT_DIALOG_DATA) private _data: Poligon,
        private _toasterService: ToasterService,
        private _translateService: TranslateService,
        private _poligonService: PoligonService,
        private _companyService: CompanyService,
        private _dialogRef: MatDialogRef<PoligonFormComponent>) {
        super();
    }

    public async ngOnInit(): Promise<void> {

        try {
            this.companyId =parseInt(localStorage.getItem("CompanyID"))
            if (this.companyId == 1) {
                this.companyList = await this._companyService.getCompanies();
            }
        } catch (error) {
            console.warn(error);
        }

    }

    public async save(): Promise<void> {
        
        if(this.form.invalid){
            this._toasterService.toastFail(
                this._translateService.instant("PLEASE_FILL_IN_THE_FORM_CORRECTLY")
            );
            return;
        }

        this.model.status =true;
        try {
            this.model.companyId = this.companyId == 1 ? this.selectedCompany : this.companyId
            let response = await this._poligonService.add(this.model);
            if (response.id) {
                this._dialogRef.close();
                this.done.emit(response.id);
            } else {
                this._dialogRef.close();
            }
        } catch (error) {
            console.warn(error);
            
        }
        
    }
}